<template>
    <div class="table-outer" >
        <div class="table-out">
            <div class="table-body" v-loading="loading">
                <div class="table-row">
                    <div class="table-cell table-cell1">
                        <b>No.</b>
                    </div> <!--INDEX-->
                    <div class="table-cell table-cell2">
                        <b>Name</b>
                    </div> <!--TEACHERS NAME-->
                    <div class="table-cell table-cell3">
                        <b>Grade</b>
                    </div> <!--GRADE-->
                    <div class="table-cell table-cell4">
                        <b>School</b>
                    </div> <!--SCHOOL NAME-->
                    <div class="table-cell table-cell5">
                        <b>District</b>
                    </div> <!--DISTRICT-->
                    <div class="table-cell table-cell6">
                        <b>State</b>
                    </div> <!--STATE-->
                    <div class="table-cell table-cell7">
                        <b>Fundraiser Progress
                            <poptip word-wrap width="200" content="This is the percentage of funding already received by this teacher. Your additional donation can contribute to helping them reach 100% of their goal to receive two Classroom Supply Boxes.">
                                <i class="fa fa-info-circle" aria-hidden="true" style="cursor: pointer"></i>
                            </poptip>
                        </b>
                    </div> <!--PROGRESS-->
                    <div class="table-cell table-cell8">
                        <b>Your Donation</b>
                    </div> <!--PROGRESS-->
                    <div class="table-cell table-cell9"> <!--DELETE DONATION BUTTON-->

                    </div>
                </div>
                <div class="table-row" v-for="(cartItem,slug,index) in cartData">
                    <div class="table-cell table-cell1"
                         :class="cartItem.is_invalid? 'text-error':''">
                        {{index+1}}
                    </div> <!--INDEX-->
                    <div class="table-cell table-cell2"
                         :class="cartItem.is_invalid? 'text-error':''">
                        {{cartItem.name}}
                    </div> <!--TEACHERS NAME-->
                    <div class="table-cell table-cell3"
                         :class="cartItem.is_invalid? 'text-error':''">
                        {{cartItem.grade}}
                    </div> <!--GRADE-->
                    <div class="table-cell table-cell4"
                         :class="cartItem.is_invalid? 'text-error':''">
                        {{cartItem.school}}
                    </div> <!--SCHOOL NAME-->
                    <div class="table-cell table-cell5"
                         :class="cartItem.is_invalid? 'text-error':''">
                        {{cartItem.district}}
                    </div> <!--DISTRICT-->
                    <div class="table-cell table-cell6"
                         :class="cartItem.is_invalid? 'text-error':''">
                        {{cartItem.state}}
                    </div> <!--STATE-->
                    <cart-table-progress :raised-amount="cartItem.raised_amount"
                                         :fundraiser-slug="slug"
                                         :goal-amount="cartItem.goal_amount">
                    </cart-table-progress>
                    <donation-amount-editor :current-amount="cartItem.raised_amount"
                                            :current-donation="cartItem.current_donation"
                                            :goal-amount="cartItem.goal_amount"
                                            :new-teacher-id="cartItem.new_teacher_id"
                                            :fundraiser-slug="slug">
                    </donation-amount-editor>
                    <div class="table-cell table-cell9"> <!--DELETE DONATION BUTTON-->
                        <i class="fa fa-trash " style="cursor:pointer;" aria-hidden="true" @click="removeFundraiserDonation(cartItem.fundraiser_id)"></i>
                    </div>
                </div>
            </div>
            <div class="table-footer table-body">
                <div class="table-row">
                    <div class="table-cell table-cell1"></div>
                    <div class="table-cell table-cell2"></div>
                    <div class="table-cell table-cell3"></div>
                    <div class="table-cell table-cell4"></div>
                    <div class="table-cell table-cell5"></div>
                    <div class="table-cell table-cell6"></div>
                    <div class="table-cell table-cell7">
                        total
                    </div>
                    <div class="table-cell table-cell8">{{totalDonationAmount}}</div> <!--TOTAL CART AMOUNT-->
                    <div class="table-cell table-cell9"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import CartTableProgress from './cart-table-subcomponents/CartTableProgress' ;
    import DonationAmountEditor from './cart-table-subcomponents/DonationAmountEditor' ;
    export default {
        mounted(){
            let vm = this;
            kinfEvents.$on('CartUpdated',ev=>{vm.$forceUpdate()});
        },
        components:{CartTableProgress,DonationAmountEditor},
        props: {
            cartData: {
                required: true,
            },
            loading:{
                required:false,
            }
        },

        computed:{
            totalDonationAmount(){
                let total = 0;
                for (let item in this.cartData){
                    total += parseInt(this.cartData[item].current_donation);
                }
                return "$"+total;
            }
        },
        methods:{
            removeFundraiserDonation(id){
                this.$confirm('Do you want to remove your donation of this teacher?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    kinfEvents.$emit('removeFundraiserDonation',id);
                }).catch(() => {
                    console.log('canceled');
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/views/checkout/components/index/CartTable.vue